var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.username && _vm.$route.path !== '/login')?_c('div',{staticClass:"watermark-container"},[_c('div',{staticClass:"watermark-pattern",style:(_vm.patternStyle)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }